import get from "lodash/get";
import map from "lodash/map";
import filter from "lodash/filter";
import find from "lodash/find";
import flatMap from "lodash/flatMap";

// Maps a user's zone locations (from getUserByID) to the ids of the matching companies.
export const getUserCompanyIds = (user, companies) =>
  flatMap(get(user, "userZoneLocationVO.locationList", []), (location) =>
    map(filter(companies, ["location_id", get(location, "id")]), "id")
  );

// Builds the create/update user payload from form-shaped values ({ name, email, roleId, enabled, locations }).
export const generateUserPayload = (values, companies) => {
  const zoneLocations = [];
  map(get(values, "locations"), (location) => {
    const company = find(companies, ["id", location]);
    if (company)
      zoneLocations.push({
        zoneNodeType: "LOCATION",
        zoneNodeId: get(company, "location_id"),
      });
  });
  return {
    name: get(values, "name"),
    email: get(values, "email"),
    user_type: "ORGANIZATION",
    organizationId: 6,
    roleId: get(values, "roleId"),
    enabled: get(values, "enabled"),
    zoneLocations,
  };
};
